import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CountryCodeRes } from '../../model/countryCoder';
import { LandingPageService } from '../../services/landing-page.service';
import { AnalyticsService } from '../../../services/analytics.service';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: [
    '../../../../assets/bootstrap/bootstrap.css',
    './contact-us.component.scss',
  ],
  standalone: true,
  imports: [
    MatDialogModule,
    FormsModule,
    CommonModule,
    MatMenuModule,
    IonIcon,
    MatSnackBarModule,
  ],
})
export class ContactUsComponent implements OnInit, OnDestroy {
  _mounted = false;
  loading: boolean = false;
  firstName: string = '';
  firstNameErrorMsg: string = '';
  lastName: string = '';
  email: string = '';
  emailErrorMsg: string = '';
  phoneNumber: string = '';
  phoneNumberErrorMsg: string = '';
  countrycode: string = '+91';
  countryCodes: CountryCodeRes[] = [];
  description: string = '';
  descriptionErrorMsg: string = '';
  submitted: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ContactUsComponent>,
    private landingPageService: LandingPageService,
    private snackBar: MatSnackBar,
    private analyticsService: AnalyticsService
  ) {
    addIcons({ closeOutline });
  }

  ngOnInit(): void {
    this._mounted = true;
    this.getCountryCodes();
  }

  ngOnDestroy(): void {
    this._mounted = false;
  }

  onClickClose() {
    this.dialogRef.close();
  }

  getCountryCodes() {
    this.landingPageService
      .getCountryCodesApi()
      .then((res: CountryCodeRes[]) => {
        this.countryCodes = res;
      })
      .catch((err) => {
        console.error(err);
        if (err.status != 401 && this._mounted) {
          setTimeout(() => {
            this.getCountryCodes();
          }, 3000);
        }
      });
  }

  selectValue(countryCode: CountryCodeRes) {
    this.countrycode = countryCode.code;
  }

  onSubmit() {
    if (this.loading) return;

    this.analyticsService.trackEvent('request_demo_submit_click', {
      event_category: 'Button',
      event_label: 'Request a Demo form submit button click',
    });

    if (!this.firstName || !this.phoneNumber) {
      this.firstNameErrorMsg = !this.firstName ? 'First name required' : '';
      this.phoneNumberErrorMsg = !this.phoneNumber
        ? 'Phone number required'
        : '';
      return;
    }

    if (this.email) {
      let emailPattern = new RegExp(
        '^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,7}$'
      );
      if (!emailPattern.test(this.email)) {
        this.emailErrorMsg = 'Enter a valid email address';
        return;
      }
    }

    this.loading = true;
    let req = {
      description: this.description,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: {
        countryCode: this.countrycode,
        number: this.phoneNumber,
      },
    };

    this.landingPageService
      .createNewEnquiryApi(req)
      .then((res: any) => {
        console.log(res);
        if (res?.message == 'new enquiry created') {
          this.submitted = true;
        } else
          this.snackBar.open('Something went wrong, Try again later', '', {
            duration: 2000,
          });
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.snackBar.open('Something went wrong, Try again later', '', {
          duration: 2000,
        });
      });
  }
}
